import { useUpdateEffect } from 'react-use';

import { useTranslate } from '@dreryk/react-common';
import { StyledFlex, Text } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../translations';
import { DocumentationAccessField } from '../MedicalDataAccessAuthorizationModalForm/fields/DocumentationAccessField';
import { InformationAccessField } from '../MedicalDataAccessAuthorizationModalForm/fields/InformationAccessField';
import { MedicalDataAccessAuthorizationFormController } from '../MedicalDataAccessAuthorizationModalForm/MedicalDataAccessAuthorizationModalForm.types';

export type AuthorizationRangeFieldProps = Pick<
   MedicalDataAccessAuthorizationFormController,
   'register' | 'watch' | 'trigger'
>;

const AUTHORIZATION_RANGE_FIELD_KEYS: ['documentationAccess', 'informationAccess'] = [
   'documentationAccess',
   'informationAccess',
];

const AuthorizationRangeField = (props: AuthorizationRangeFieldProps): JSX.Element => {
   const translate = useTranslate();
   const { documentationAccess, informationAccess } = props.watch(AUTHORIZATION_RANGE_FIELD_KEYS);

   useUpdateEffect(() => {
      props.trigger(AUTHORIZATION_RANGE_FIELD_KEYS);
   }, [documentationAccess, informationAccess]);

   return (
      <StyledFlex direction={'column'} gap={'8px'}>
         <Text testId={'selectAtLeastOne'}>
            {translate(patientConsentsAndAuthorizationsTranslationKeys.authorizations.selectAtLeastOne)}
         </Text>
         <InformationAccessField register={props.register} />
         <DocumentationAccessField register={props.register} />
      </StyledFlex>
   );
};

export { AuthorizationRangeField };
